import React from 'react';
import {
  Box,
  Typography,
  Button,
  Divider,
  Stack,
} from '@mui/material';
import {
  Add,
} from '@mui/icons-material';
import LocationsTitle from './LocationsTitle';
import EditLocation from '../../components/EditLocation';
import EditAdditionalLocation from '../../components/EditAdditionalLocation';
import { OperationLocation } from 'src/networkRequest/operationsService';

export interface OperationLocationsProps {
  primaryLocation: OperationLocation;
  additionalLocations: OperationLocation[];
  onPrimaryLocationChange: (field: string, value: string) => void;
  onAdditionalLocationChange: (id: string, field: string, value: string) => void;
  onAddLocation: () => void;
  onDeleteLocation: (id: string) => void;
}

export default function OperationLocations({
  primaryLocation,
  additionalLocations,
  onPrimaryLocationChange,
  onAdditionalLocationChange,
  onAddLocation,
  onDeleteLocation,
}: OperationLocationsProps) {
  const sectionWidth = 832;

  return (
    <>
      <LocationsTitle />

      <Box sx={{
        p: 2,
        backgroundColor: (theme) => theme.palette.blueGrey[50],
        borderRadius: '10px',
        width: '100%',
        maxWidth: sectionWidth
      }}>
        <Stack spacing={2}>
          <EditLocation
            title="Primary Location"
            locationData={primaryLocation}
            onLocationDataChange={onPrimaryLocationChange}
            backgroundColor="transparent"
          />

          {additionalLocations.length > 0 && (
            <>
              <Divider />
              <Typography variant="h6">Additional Locations</Typography>

              {additionalLocations.map((location, index) => (
                <React.Fragment key={location.id}>
                  <EditAdditionalLocation
                  key={location.id}
                    title=""
                    locationData={location}
                    onLocationDataChange={(field, value) => onAdditionalLocationChange(location.id, field, value)}
                    backgroundColor="transparent"
                    showDelete={true}
                    onDelete={() => onDeleteLocation(location.id)}
                  />
                  {index < additionalLocations.length - 1 && (
                    <Divider />
                  )}
                </React.Fragment>
              ))}
            </>
          )}

          <Button
            variant="outlined"
            color="secondary"
            size="small"
            startIcon={<Add />}
            onClick={onAddLocation}
            sx={{ alignSelf: 'flex-start' }}
          >
            Location
          </Button>
        </Stack>
      </Box>
    </>
  );
}